import React, { createContext, useContext, useState } from "react";

// Shared sidebar collapse state so the top header bar can react to it:
// expanded → logo lives in the sidebar; collapsed → logo shows in the navbar.
interface SidebarCtx {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const SidebarContext = createContext<SidebarCtx>({
  isCollapsed: false,
  setIsCollapsed: () => {},
});

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <SidebarContext.Provider value={{ isCollapsed, setIsCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
